import classnames from 'classnames'
import React, { useCallback } from 'react'

// Types
import { FeatureSectionTwo, IconWithTextProps } from '@src/quince-components/src'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import RichText from '@src/quince-site-common/src/domains/RichText'
import TrackingEvent from '@src/quince-site-common/src/helpers/tracking-event/tracking-event'
import { computeScrollPercentage } from '@src/quince-site-common/src/hooks/useScrollEventTracker'
import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
// Components

// Helpers
import { isFS2SectionDataValid } from '../../../helper/product.helper'

import * as styles from './stackedImageWithTextProductDetailsSection.module.scss'
const FEATURE_SECTION_2_HEADING = 'Feature Section'
interface ImageWithTextProductDetailsSectionProps {
  prodDetails: CustomSection
}
function ImageWithTextProductDetailsSection({ prodDetails }: ImageWithTextProductDetailsSectionProps) {
  const getIsVisibleTrackParams = useCallback(() => {
    return {
      action: 'feature_section_two_viewed',
      value: true,
      context: {
        contentContainerType: prodDetails.contentContainerType,
        contentContainerName: prodDetails.contentContainerName,
        trackingId: prodDetails.trackingId,
        contentContainerDisplayName: prodDetails.displayTitle,
        is_in_first_fold: computeScrollPercentage() === 0,
      },
    }
  }, [prodDetails])

  return (
    <>
      {isFS2SectionDataValid(prodDetails) && (
        <div className={classnames(styles.imageWithTextProductDetailsSection, 'desktopOnly')}>
          <RenderSection prodDetails={prodDetails} getIsVisibleTrackParams={getIsVisibleTrackParams} />
        </div>
      )}
      {isFS2SectionDataValid(prodDetails) && (
        <div className={classnames(styles.imageWithTextProductDetailsSection, 'mobileOnly')}>
          <RenderSection prodDetails={prodDetails} getIsVisibleTrackParams={getIsVisibleTrackParams} />
        </div>
      )}
    </>
  )
}
const RenderSection: React.FC<{
  prodDetails: CustomSection
  getIsVisibleTrackParams: () => any
}> = ({ prodDetails, getIsVisibleTrackParams }) => {
  const shouldTrackVisible = prodDetails.trackingTypes?.includes(TrackingEvent.TRACKING_BROWSER_EVENT_TYPES.VISIBLE)
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(shouldTrackVisible ? getIsVisibleTrackParams : () => null)
  const layoutType = prodDetails.layoutType
  const iconsWithTextDesktop: IconWithTextProps[] = (prodDetails.subSections ?? []).map(pss => ({
    iconProps: {
      title: pss.images ? pss.images[0].title : '',
      url: pss.images ? `https:${pss.images[0].url}` : '',
    },
    heading: pss.displayTitle ?? '',
    description: RichText.makeRichTextProps(pss.richTexts ? pss.richTexts[0] : undefined),
  }))
  const classNames = prodDetails.classNames
  return (
    <FeatureSectionTwo
      heading={FEATURE_SECTION_2_HEADING}
      imageProps={
        prodDetails.images && prodDetails.images.length > 0
          ? {
              title: prodDetails.images[0].title,
              url: `https:${prodDetails.images[0]?.url}` || '',
            }
          : null
      }
      videoProps={
        prodDetails.videos && prodDetails.videos.length > 0
          ? {
              id: `https:${prodDetails.videos[0]?.id}`,
              url: `https:${prodDetails.videos[0]?.url}`,
              contentType: `https:${prodDetails.videos[0]?.contentType}`,
            }
          : null
      }
      contents={iconsWithTextDesktop}
      ref={trackIsVisibleRef}
      layoutType={layoutType}
      className={classnames(classNames)}
    />
  )
}
export default ImageWithTextProductDetailsSection
